<template>
    
    <footer class="footer fixed-bottom mt-auto py-3 border-top border-top-light bg-white">
        <div class="w-75 mx-auto text-center">
            <span class="text-muted">
                <div>
                    &copy; {{ new Date().getFullYear() }} — <strong>#techsense</strong>
                </div>
            </span>
        </div>
    </footer>
</template>

<script>

    import {
        mapActions,
        mapState
    } from 'vuex';

    export default {
        data() {
            return {
                
            }
        },
        mounted() {
            
        },
        computed: {
           
        },
        methods: {
        
        }
    }
</script>